import { Publicprofile } from '@/payload-types'
import { ProfileCardComponent } from '@/components/public-profile-card/profileCard'
import { createProfileDetails } from '@/lib/profileFunction'
import RenderRichTexComponent from '../rich-text-render/richTextRender'

interface IProps {
  profileData: (string | null) | Publicprofile
}

export const RegularPostProfileCard = ({ profileData }: IProps) => {
  const arrayOfData = createProfileDetails(profileData)
  return (
    <div className="my-[20px] bg-gray-50 rounded-md default-border shadow-cards p-[12px] w-[254px] ml-2.5 md:w-auto md:ml-0 md:flex">
      <ProfileCardComponent
        profileData={profileData}
        profilePicture={{
          pictureDivCSS: 'h-48 md:h-44 md:w-44 md:mr-[12px]',
          pictureCSS: 'rounded-md default-border',
        }}
        profileFullName={{
          fullNameDivCSS: 'mb-0.5 mt-3 md:mt-0',
          fullNameCSS: 'font-bold text-lg leading-[27px]',
        }}
        moreDetails={{ ifShow: true, ifFlex: true, value: arrayOfData, showMore: false }}
        profileDescription={{
          ifShow: true,
          descriptionNode:
            profileData && typeof profileData === 'object' && 'overview' in profileData ? (
              <div className={`profileDescriptionCampaignRegular`}>
                <RenderRichTexComponent richTextField={profileData.overview} textOnly={true} />
              </div>
            ) : (
              <></>
            ),
        }}
        seeProfileBtn={{ ifShow: true, btnCSS: 'mt-2' }}
      />
    </div>
  )
}

export default RegularPostProfileCard
